import { manifestApi } from '../../api/manifestApi.js'

import { agentManifestSignal, agentManifestLoadedSignal, agentManifestErrorSignal } from '../signals/agentManifestSignals.js'

export const fetchAgentManifest = async (config, accessToken) => {
    agentManifestLoadedSignal.value = false
    agentManifestSignal.value = null
    return await manifestApi.fetchAgentManifest(config, accessToken).then(
        (data) => {
            agentManifestSignal.value = data
            agentManifestLoadedSignal.value = true
            return data
        }
    ).catch(
        (err) => {
            agentManifestErrorSignal.value = err
        }
    )
}